import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import lexoAnimatedLogo from '@/assets/icons/lexo-animated-logo.svg';

interface Props {
    mainText?: string;
    subText?: string;
}

export default function LexoLoadingCard({ mainText, subText }: Props) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                width: '400px',
                maxWidth: '400px',
                padding: '24px',
                boxSizing: 'border-box',
                gap: '16px',
                borderRadius: '4px',
                backgroundColor: theme.palette.primary.P_600,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '130px',
                }}
            >
                <img width="50" src={lexoAnimatedLogo} alt="" />
            </div>
            <Typography
                sx={{
                    marginBottom: '8px',
                    color: theme.palette.neutral.white,
                    textAlign: 'center',
                }}
                variant="h3"
            >
                {mainText}
            </Typography>
            <Typography
                sx={{
                    marginBottom: '8px',
                    color: theme.palette.neutral.white,
                    textAlign: 'center',
                }}
                variant="body2"
            >
                {subText}
            </Typography>
        </Box>
    );
}
